<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>For my parents, with love</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7aa60482